<script>
import ListUsersComponent from '../../features/lists/ListUsersComponent';
import ModalUserView from '../modals/ModalUserView';
import ModalImportView from '../../../shared/views/ModalImportView';


export default {
  name: 'ListUserView',
  components: {
    'modal-user-view': ModalUserView,
    'modal-import': ModalImportView,
  },
  extends: ListUsersComponent,
};
</script>

<template>
  <div class="list-body">
    <el-row :gutter="20" class="section-ctrl">
    <el-col :xs="24" :sm="14" :md="14" :lg="14" :xl="14" class="header-right">
        <el-button-group class="btn-grp-drp">
          <el-button
            type="primary"
            size="small"
            class="btn-primary"
            icon="el-icon-circle-plus"
            :disabled="!onCanCreate(modulePermissions)"
            @click="onCreate"
          >
            Crear Usuario
          </el-button>
          <el-dropdown>
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i class="fa fa-ellipsis-v" /> <span class="hidden-xs-only">M&aacute;s Opciones</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light"
                    icon="el-icon-upload"
                    :disabled="!onCanCreate(modulePermissions)"
                    @click="onShowImport"
                  >
                    Importar Usuarios
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onExportToExcel()"
                  >
                    <i
                      class="fa fa-file-excel-o"
                      aria-hidden="true"
                    /> Exportar
                    Excel
                  </el-button>
                </el-dropdown-item>
              <!--<el-dropdown-item>
                <el-button size="small" class="btn-white">
                  <i class="fa fa-file-pdf-o" aria-hidden="true"></i> Exportar PDF
                </el-button>
              </el-dropdown-item>-->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            popper-class="filter-dropdown-popper"
          >
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i
                class="fa fa-filter"
                aria-hidden="true"
              /> <span class="hidden-xs-only">Filtrar Por</span> <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.status"
                    size="small"
                    clearable
                    placeholder="Estado..." 
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.status, 'Status')"
                    @focus="onFocusUserStatus"
                  >
                    <el-option
                      v-for="item in userStatuses"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.roleFilter"
                    size="small"
                    filterable
                    remote
                    clearable
                    placeholder="Role..."
                    :remote-method="onSearchRole"
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.roleFilter.name, 'Role')"
                    @focus="onFocusRole"
                  >
                    <el-option
                      v-for="item in roles"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-button-group>
    </el-col>
    <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10" class="header-left search-inputs-row">
        <el-input
          v-model="searchFullName"
          size="small"
          placeholder="Buscar Usuario..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(searchFullName, 'UserName')"
        />
        <el-input
          v-model="searchEmail"
          size="small"
          placeholder="Buscar Correo..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(searchEmail, 'Email')"
        />
    </el-col>
    </el-row>
    <el-table
      v-loading="isListLoading"
      :data="collection"
      empty-text="No se encontraron resultados."
      element-loading-spinner="el-icon-loading"
      :element-loading-text="listLoadingMessage"
    >
      <!-- <el-table-column label="NO. EMPLEADO" width="140" align="center">
        <template scope="scope">
          <div>
            <el-tag type="info" effect="plain">
              {{ scope.row.employeeCode }}</el-tag
            >
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
        label="USUARIO"
        min-width="180"
      >
        <template #default="scope">
          <div>
            <el-tag
              type="info"
              effect="plain"
            >
              <i class="uil uil-user" />
              {{ scope.row.userName.toUpperCase() }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="CORREO"
        min-width="350"
      >
        <template #default="scope">
          <div>
            <el-tag
              type="info"
              effect="plain"
            >
              <i class="uil uil-envelope-check" />
              {{ scope.row.email.toUpperCase() }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="ROL"
        align="center"
        min-width="150"
      >
        <template #default="scope">
          <div>
            <el-tag
              type="info"
              effect="plain"
            >
              <i class="uil uil-users-alt" />
              {{ scope.row.role.toUpperCase() }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="ESTADO"
        align="center"
        text-align="center"
        width="110"
      >
        <template #default="scope">
          <div>
            <el-tag
              v-if="!scope.row.status || scope.row.status === 1"
              type="danger"
              effect="plain"
            >
              <i class="fa fa-times-circle" /> INACTIVO
            </el-tag>
            <el-tag
              v-if="scope.row.status === 2"
              type="success"
              effect="plain"
            >
              <i class="fa fa-check-circle" /> ACTIVO
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="OPCIONES"
        :width="160"
        align="center"
        text-align="center"
      >
        <template #default="scope">
          <el-dropdown @command="onChangeItemOptions">
            <el-button size="small">
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
              />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="{ command: 'edit', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-edit"
                    aria-hidden="true"
                  /> Mostrar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'delete', item: scope.row }"
                  :disabled="!onCanDelete(modulePermissions)"
                >
                  <i
                    class="el-icon-delete"
                    aria-hidden="true"
                  /> Eliminar
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-model:current-page="currentPage"
      size="small"
      layout="prev, pager, next"
      :page-count="pagination.totalPages"
      @current-change="onPageChange"
    />
    <modal-user-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>

